import { BasicSeries, IssueType } from './../../../types/deal.types';

export function issueTypeValueGetter(series: BasicSeries): string {
  const { refunding, remarketing, advancedRefunding, newMoney } = series;

  if (refunding && refunding.enabled) {
    return IssueType.refunding;
  }
  if (remarketing && remarketing.enabled) {
    return IssueType.remarketing;
  }
  if (advancedRefunding && advancedRefunding.enabled) {
    return IssueType.advancedRefunding;
  }
  if (newMoney && newMoney.enabled) {
    return IssueType.newMoney;
  }
  return IssueType.newMoney;
}

export function issueTypeGridValueGetter(node: {
  data: { series: BasicSeries[] };
}): string[] {
  const issueType: string[] = node.data.series.map(s =>
    issueTypeValueGetter(s)
  );

  return issueType.reduce(
    (innerAcc: string[], _issueType: string) =>
      innerAcc.includes(_issueType) ? innerAcc : [...innerAcc, _issueType],
    []
  );
}
